import { NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ButtonModule } from '@openng/optimus-ui/button';
import { DialogModule } from '@openng/optimus-ui/dialog';

import { AppConfigErrorDialogService } from '@app/theme/app-config-error-dialog/app-config-error-dialog.service';

@Component({
    selector: 'cor-app-config-error-dialog',
    template: `
        <p-dialog
          [(visible)]="appConfigErrorDialogService.visible"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          maskStyleClass="tw:bg-neutral-400!"
          styleClass="tw:w-[30rem]">
          <div class="tw:flex tw:flex-col tw:gap-3 tw:items-center">
            <img
              alt="Configuration Error"
              ngSrc="assets/images/svg/oh-snap.svg"
              priority
              [width]="139"
              [height]="130" />
            <div class="tw:font-bold tw:text-4xl">Configuration Error</div>
            <div class="tw:text-center">
              Unable to load GenGuardX configurations.
              <br />
              Please contact your administrator to resolve this issue.
            </div>
            @if (appConfigErrorDialogService.errorMessage()) {
              <div class="tw:text-center tw:text-muted-color tw:text-sm">
                {{ appConfigErrorDialogService.errorMessage() }}
              </div>
            }
          </div>

          <ng-template pTemplate="footer">
            <div class="tw:flex tw:flex-auto tw:justify-center tw:my-2">
              <p-button
                test-id="app-config-error-dialog-refresh-page"
                [buttonProps]="{ autofocus: false }"
                icon="pi pi-sync"
                label="Refresh page"
                (click)="reloadPage()" />
            </div>
          </ng-template>
        </p-dialog>
    `,
    imports: [DialogModule, ButtonModule, NgOptimizedImage],
})
export class AppConfigErrorDialogComponent {
    protected readonly appConfigErrorDialogService = inject(AppConfigErrorDialogService);

    reloadPage() {
        window.location.reload();
    }
}
